var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_47",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 106
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.376953,
    y: 0.0610352,
    width: 105.184,
    height: 105.184,
    fill: "#6A7878"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2734 31.8777C45.9071 30.6918 49.504 30.0908 52.9673 30.0908C72.612 30.0908 89.9032 49.1943 95.1143 55.5521C93.2491 57.8365 89.8364 61.7557 85.3346 65.8223C83.9207 67.1027 83.8102 69.2857 85.0882 70.7018C85.7721 71.4548 86.7093 71.8394 87.6511 71.8394C88.4778 71.8394 89.3068 71.5446 89.9677 70.9482C97.5045 64.1344 102.105 57.8411 102.299 57.5762C103.178 56.3673 103.178 54.7278 102.299 53.5165C101.398 52.2823 79.9554 23.1826 52.9673 23.1826C48.7763 23.1826 44.4587 23.8987 40.1319 25.3103C38.3173 25.9021 37.3271 27.8525 37.9212 29.6648C38.5107 31.4816 40.4658 32.4741 42.2734 31.8777ZM8.70183 9.49512C7.26492 8.24474 5.08193 8.39211 3.82924 9.83132C2.57425 11.2682 2.72623 13.4489 4.16314 14.7039L25.0881 32.9393C12.377 41.6252 4.01576 53.0007 3.63811 53.5211C2.76077 54.7301 2.76077 56.3696 3.63811 57.5808C4.53618 58.8174 25.9793 87.9171 52.9673 87.9171C61.3032 87.9171 69.9293 85.0962 78.6313 79.5996L97.2328 95.8109C97.8868 96.3819 98.695 96.6606 99.4987 96.6606C100.464 96.6606 101.421 96.2599 102.105 95.4747C103.358 94.0378 103.208 91.8548 101.769 90.6021L8.70183 9.49512ZM43.8232 49.2634L59.3252 62.7735C57.5129 64.1459 55.2885 64.9335 52.9673 64.9335C47.1598 64.9335 42.4323 60.206 42.4323 54.3985C42.4323 52.5563 42.9458 50.8177 43.8232 49.2634ZM52.9673 81.0089C33.3227 81.0089 16.0337 61.9077 10.8226 55.5475C13.8761 51.8148 21.109 43.723 30.5064 37.6599L38.5107 44.6372C36.5718 47.4926 35.5218 50.8523 35.5218 54.3985C35.5218 64.017 43.3465 71.8417 52.965 71.8417C57.2919 71.8417 61.4253 70.2067 64.5961 67.3698L73.1784 74.8491C66.2196 78.9272 59.4334 81.0089 52.9673 81.0089Z",
    fill: "#606060"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnView);
export default __webpack_public_path__ + "static/media/unView.ee809fc8bcac5195ac85cf892cf31571.svg";
export { ForwardRef as ReactComponent };